"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tquery getUserForSidebar {\n\t\tviewer {\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t\tusername\n\t\t\t\timage {\n\t\t\t\t\tcloudinaryID\n\t\t\t\t}\n\t\t\t\tpersonal {\n\t\t\t\t\tid\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tquery getUserForSidebar {\n\t\tviewer {\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t\tusername\n\t\t\t\timage {\n\t\t\t\t\tcloudinaryID\n\t\t\t\t}\n\t\t\t\tpersonal {\n\t\t\t\t\tid\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouterDom = require("react-router-dom");

var _reactApollo = require("react-apollo");

var _cloudinaryImage = require("../../cloudinaryImage");

var _cloudinaryImage2 = _interopRequireDefault(_cloudinaryImage);

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//------------------------------

var getUser = (0, _reactApollo.gql)(_templateObject);

var getLinkTo = function getLinkTo(props) {
	return "/app/" + _ramda2.default.pathOr("", ["getUser", "viewer", "user", "personal", "id"], props);
};

var getImageID = _ramda2.default.path(["getUser", "viewer", "user", "image", "cloudinaryID"]);

//------------------------------

exports.default = (0, _reactApollo.graphql)(getUser, {
	name: "getUser",
	skip: function skip(ownProps) {
		return ownProps.placeholder || ownProps.addNew;
	}
})(function (props) {
	return _react2.default.createElement(
		_reactRouterDom.Link,
		{ to: getLinkTo(props) },
		_react2.default.createElement(
			_styles.OrgImage,
			{ active: props.active },
			_react2.default.createElement(_cloudinaryImage2.default, (0, _extends3.default)({
				isButton: true,
				height: _styles.orgImageSize,
				width: _styles.orgImageSize,
				transformations: [_cloudinaryImage2.default.commonTransforms.smartSquare, {
					radius: 4
				}]
			}, getImageID(props) ? { cloudinaryID: getImageID(props) } : {
				url: "http://www.thechamberlainfiles.com/wp-content/uploads/2015/08/corbyn-e1439420143640-500x300.png"
			}))
		)
	);
});

//# sourceMappingURL=userButton.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/shell/button/userButton.js
// module id = 379
// module chunks = 0